var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconFolderShared = function SvgIconFolderShared(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 4.99999H9.99984L8.82484 3.825C8.50817 3.50833 8.08317 3.33333 7.6415 3.33333H3.33317C2.4165 3.33333 1.67484 4.08333 1.67484 4.99999L1.6665 15C1.6665 15.9167 2.4165 16.6667 3.33317 16.6667H16.6665C17.5832 16.6667 18.3332 15.9167 18.3332 15V6.66666C18.3332 5.74999 17.5832 4.99999 16.6665 4.99999ZM12.4998 7.49999C13.4165 7.49999 14.1665 8.24999 14.1665 9.16666C14.1665 10.0833 13.4165 10.8333 12.4998 10.8333C11.5832 10.8333 10.8332 10.0833 10.8332 9.16666C10.8332 8.24999 11.5832 7.49999 12.4998 7.49999ZM15.8332 14.1667H9.1665V13.3333C9.1665 12.225 11.3915 11.6667 12.4998 11.6667C13.6082 11.6667 15.8332 12.225 15.8332 13.3333V14.1667Z",
    fill: "#313336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconFolderShared);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-folder-shared.845db25ae51bd4b1ef9e7cf6161889bf.svg";